import { render } from "./Mint.vue?vue&type=template&id=8d4878f8&scoped=true"
import script from "./Mint.vue?vue&type=script&lang=js"
export * from "./Mint.vue?vue&type=script&lang=js"

import "./Mint.vue?vue&type=style&index=0&id=8d4878f8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4878f8"]])

export default __exports__